import { FaPhoneAlt } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import ContactForm from "../forms/contactForm";
import CtaOffer from "../common/ctaOffer";

function Offer1FrezowaniePni() {
  return (
    <>
      {/* HERO */}
      <section className="relative overflow-x-hidden flex flex-col lg:flex-row items-center justify-between lg:min-h-[60vh] p-6 lg:px-12 lg:pt-48 lg:pb-36 gap-6">
        <img
          className="absolute w-full h-full object-cover z-10 top-0 left-0"
          src="https://magazyn.drzewus.pl/wp-content/uploads/2025/04/frezowanie-pni-1.jpeg"
          alt="Frezowanie pni - usuwanie pni drzew - Drzewus"
        />
        <div className="w-full h-full object-cover z-20 absolute top-0 left-0 gradient-green-ltr"></div>
        <div className="flex flex-col items-start justify-center gap-2 z-30">
          <h1 className="text-3xl lg:text-6xl text-white text-left">
            Frezowanie pni drzew po wycince Gdańsk, Gdynia, Wejherowo
          </h1>
          <h2 className="text-xl lg:text-3xl text-white text-left">
            Bezinwazyjne usuwanie karp i pniaków na działce
          </h2>
          <p className="text-white text-base lg:text-xl max-w-[850px] text-left">
            Pozostałe po wycince pniaki i korzenie skutecznie utrudniają przygotowanie działki pod budowę domu lub założenie trawnika. DRZEWUS oferuje szybkie i bezinwazyjne frezowanie pni na terenie Gdańska, Gdyni, Kartuz, Wejherowa i Kaszub przy użyciu nowoczesnych frezarek. Usuniemy pnie na każdej głębokości bez niszczenia otoczenia, przygotowując grunt pod dalsze <a href="/oczyszczanie-terenu/prace-ziemne" className="underline hover:opacity-80">prace ziemne</a> i <a href="/zakladanie-ogrodu/kompleksowo" className="underline hover:opacity-80">zakładanie ogrodów</a>.
          </p>
          <a href="#wiecej">
            <button className="button-yellow">Dowiedz się więcej</button>
          </a>
        </div>
        <div className="z-30 max-w-[500px] flex flex-col items-center justify-center">
          {" "}
          <ContactForm />
        </div>
      </section>
      {/* CONTENT */}
      <section
        id="wiecej"
        className="p-6 lg:px-24 lg:py-12 grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-12"
      >
        <div className="lg:col-span-1 flex flex-col gap-6">
          <div className="flex flex-col gap-2 p-6 rounded-xl bg-green w-full">
            <a
              href="#1"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Frezowanie pni drzew
            </a>
            <a
              href="#2"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Jak poradzić sobie z usunięciem pni
            </a>
            <a
              href="#3"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Frezowanie pniaków - skuteczna metoda na usuwanie pni
            </a>
            <a
              href="#4"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Gdzie sprawdzi się frezowanie pni drzew
            </a>
            <a
              href="#5"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Niezawodny sprzęt do usuwania pni drzew
            </a>
            <a
              href="#6"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Cena za frezowanie pni i korzeni
            </a>
          </div>

          <CtaOffer />
        </div>
        <div className="lg:col-span-2 flex flex-col items-start justify-start text-left gap-2 content-offer">
          <h2 id="1">Frezowanie pni drzew</h2>
          <p>
            Masz do usunięcia pień drzewa? Skontaktuj się z nami i pozbądź się
            problemu z pniakami na działce. Frezowanie pozwoli szybko i sprawnie
            usunąć wystające pnie razem z korzeniami.
          </p>
          <p>
            Frezowanie to mechaniczne usuwanie pnia oraz korzeni i to zarówno
            wystających nad grunt, jak i tych pod powierzchnią ziemi. Szybko
            obracająca się tarcza tworzy frezy i zabiera niewielkie warstwy
            drzewa, mieląc go przy tym na trociny.
          </p>
          <p>
            W ten sposób znacznie szybciej pozbędziesz się korzeni i pni w
            porównaniu do ich wykopania.{" "}
            <strong>
              Nie będziesz też mieć zmartwienia, co zrobić z pozostałościami po
              wykopanym pniu.
            </strong>{" "}
            Jeśli zostawisz w ziemi pień po ściętym drzewie, to może Ci on
            przeszkadzać. Łatwo się o niego potknąć. Utrudnia też koszenie
            trawnika. Przy inwestycjach może blokować przejście do kolejnych
            etapów budowy. Rozdrabnianie pniaków frezarką zdejmie Ci ten kłopot
            z głowy.
          </p>
          <h2 id="2">Jak poradzić sobie z usunięciem pni</h2>
          <p>
            Jeśli masz na działce pnie drzew po wycince, to możesz się ich łatwo
            pozbyć. Z pomocą przychodzi szlifowanie pniaków frezarką. Nie wymaga
            to wjazdu ciężkiego sprzętu na działkę.{" "}
          </p>
          <p>
            W przeciwieństwie do karczowania, frezowanie nie wiąże się z
            wykopywaniem pnia razem z korzeniami. Mimo to taka usługa pozwala
            pozbyć się nie tylko pniaków, ale też korzeni do głębokości 38 cm.
            Nie ma tu żadnych ograniczeń co do średnicy usuwanego pnia. Jest to
            ważne, bo całkowite usunięcie pnia po dużym drzewie może być trudne
            nawet dla koparki.
          </p>
          <p>
            Po usunięciu pnia przez frezowanie od razu możesz wykorzystać teren,
            który zajmował pień. Wyobraź sobie, co zrobisz z odzyskanym
            miejscem. Możliwości jest wiele: nowe drzewko, większy trawnik czy
            nowa rabata kwiatowa. W tym również możemy Cię wyręczyć, bo nasza
            firma zajmuje się też zakładaniem ogrodów i pielęgnacją terenów
            zielonych.
          </p>
          <h2 id="3">Frezowanie pniaków - skuteczna metoda na usuwanie pni</h2>
          <p>
            Frezowanie jest dużo szybsze od wykopania całego pniaka. Nie ma
            tutaj też zagwozdki z tym, co zrobić z korzeniami i pozostałością po
            drzewie lub czym uzupełnić ubytek ziemi po wykopanym pniu. Dlatego
            frezowanie to najprostszy sposób na usunięcie korzeni i pniaków.
            Dzięki temu to, ile kosztuje taka usługa frezowania, może Cię miło
            zaskoczyć.
          </p>
          <p>
            Natomiast jeśli w miejscu po pniu ma stanąć na przykład fundament,
            to w tym wypadku trzeba zapewnić stabilne podłoże, a do tego
            konieczne będzie karczowanie pni, czyli wykopanie ich razem z
            korzeniami. Ponieważ świadczymy kompleksowe usługi związane z
            wycinką drzew i ogrodami, to możesz nam zlecić również takie
            zadanie.
          </p>
          <p>
            Działamy na terenie województwa pomorskiego. Wykonamy frezowanie pni
            w Gdańsku, Kartuzach, Wejherowie oraz w ich okolicy. Przygotujemy
            dla Ciebie indywidualną wycenę oraz uzgodnimy termin i zakres prac
            do wykonania.
          </p>
          <h2 id="4">Gdzie sprawdzi się frezowanie pni drzew</h2>
          <p>
            Posiadamy taki sprzęt, który zapewni{" "}
            <strong>skuteczne usuwanie pni o każdych gabarytach</strong>.
            Poprzez frezowanie pozbędziesz się nie tylko wystającego pnia, ale
            też jego części ukrytej pod ziemią.
          </p>
          <p>
            Jeśli musisz pozbyć się większej ilości pni pozostałych po wycince
            drzew, a zależy Ci na czasie, to frezarka do pni poradzi sobie z
            nimi znacznie szybciej w porównaniu z ręcznym, a nawet mechanicznym
            wykopywaniem każdego pnia. Dzięki temu zaoszczędzisz sporo czasu,
            wysiłku i nerwów związanych z oczyszczeniem działki, które jest
            zajęciem fizycznie ciężkim, a do tego czasochłonnym.
          </p>
          <p>
            <strong>
              Zajmujemy się zarówno usuwaniem pni, jak i oczyszczaniem działek
              pod inwestycje.
            </strong>{" "}
            Pomożemy Ci pozbyć się pniaków w krótkim czasie. Nie zużyjesz na to
            ani odrobiny swojej siły, wszystko zrobimy za Ciebie. Zamiast samemu
            męczyć się z usuwaniem pni – zleć to profesjonalistom.
          </p>
          <p>
            Nasza oferta skierowana jest nie tylko do osób prywatnych.
            <strong>Obsługujemy firmy drogowe oraz budowlane.</strong>{" "}
            Współpracujemy z deweloperami i instytucjami{" "}
            <strong>przy oczyszczaniu terenu pod budowę i inwestycje.</strong>
          </p>
          <h3 id="5">Niezawodny sprzęt do usuwania pni drzew</h3>
          <p>
            Do prac wykorzystujemy specjalistyczny sprzęt, czyli frezarkę do pni
            model SGX60 Bobcat. Najważniejszą cechą tej frezarki jest wysoki
            przepływ oleju hydraulicznego. Dzięki takiemu rozwiązaniu bęben
            frezujący pracuje z większą prędkością i siłą, co pozwala nam w
            krótkim czasie rozprawić się nawet z największymi pniakami.
          </p>
          <p>
            Nasza frezarka SGX60 to gwarancja szybkiej i dokładnej pracy. Gumowe
            osłony ochronią Twój ogród przed ścinkami usuwanego pnia. Ponieważ{" "}
            <strong>
              proces frezowania jest prostszy i wymaga mniejszej ilość pracy niż
              proces karczowania
            </strong>
            , ma to wpływ na ostateczną cenę wykonania usługi. W przeciwieństwie
            do karczowania, przy szlifowaniu pniaków odpadają też koszty
            utylizacji usuwanych korzeni.
          </p>
          <h3 id="6">Cena za frezowanie pni i korzeni</h3>
          <p>
            Koszt usługi zależy od ilości usuwanych pni, ich średnicy i rodzaju
            drzewa. Pozostałości po wycince twardszych drzew, takich jak dąb,
            buk czy jesion, wymagają więcej pracy niż pnie drzew o bardziej
            miękkim drewnie, jak sosna czy świerk.
          </p>
          <p>
            Cena za usunięcie pnia obejmuje też koszty dojazdu sprzętu. Dlatego,
            jeśli masz do usunięcia tylko jeden pień, to żeby zmniejszyć
            ostateczną cenę, zatrudnij nas do innych prac, które możemy wykonać
            dla Ciebie w Twoim ogrodzie. Przy kompleksowej usłudze koszt dojazdu
            rozłoży się na poszczególne prace.
          </p>
          <p>
            Jeśli chcesz otrzymać wycenę, to wypełnij formularz i podaj w nim
            średnicę pni do usunięcia. Gdy znasz gatunek drzew, to też możesz
            nam go podać.
          </p>
          <p>
            Dodatkowo możesz przekazać nam dokładną lokalizację za pomocą
            pinezki oraz zdjęcia terenu, by ułatwić nam przygotowanie dokładnej
            wyceny, jednak nie jest to niezbędnie konieczne.
          </p>
          <p>
            Wyślij do nas zapytanie o frezowanie pni, a my z przyjemnością
            przedstawimy Ci naszą ofertę. Ponieważ działamy kompleksowo, to
            możesz zatrudnić nas również do innych prac związanych z ogrodem. W
            ofercie mamy zakładanie trawników, niwelacje terenu, prace ziemne
            czy usługi glebogryzarki. Z chęcią doradzimy i podpowiemy jakie
            rozwiązanie będą najlepsze dla Ciebie!
          </p>
        </div>
      </section>
      {/* PORTFOLIO */}
      <section className="p-6 lg:px-24 lg:py-12 flex flex-col gap-6">
        <div className="flex flex-col items-center justify-center mb-6">
          <h2 className="uppercase color-yellow text-xl text-center">
            Nasze realizacje
          </h2>
          <h3 className="text-3xl lg:text-5xl color-green text-center">
            Spójrz jak pomogliśmy<br></br>
            <span className="color-yellow">naszym Klientom</span>
          </h3>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/02/frezowanie-realizacja-1-1.jpeg"
              alt="Frezowanie pni - realizacja Drzewus nr 1"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/02/frezowanie-realizacja-2-1.jpeg"
              alt="Frezowanie pni - realizacja Drzewus nr 2"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-1">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/02/frezowanie-realizacja-3-2.jpeg"
              alt="Frezowanie pni - realizacja Drzewus nr 3"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/02/frezowanie-realizacja-4-1.jpeg"
              alt="Frezowanie pni - realizacja Drzewus nr 4"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-1">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/02/the-picture-after-felling-is-a-lot-of-stumps-of-co-2024-10-18-09-16-25-utc-Large.jpeg"
              alt="Pnie po wycince drzew - teren do frezowania"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/02/tree-stump-in-the-forest-cutting-down-tree-in-the-2024-09-16-12-08-22-utc-Large.jpeg"
              alt="Pieniek drzewa w lesie - przed frezowaniem"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/04/frezowanie-pni-2.jpeg"
              alt="Frezowanie pni - realizacja Drzewus nr 7"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/06/Frezarka-1.jpg"
              alt="Frezarka do pni w pracy - Drzewus nr 8"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-1">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/06/Frezarka-2.jpg"
              alt="Frezarka do pni w pracy - Drzewus nr 9"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-1">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/06/Frezarka-3.jpg"
              alt="Frezarka do pni w pracy - Drzewus nr 10"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/06/Frezarka-4.jpg"
              alt="Frezarka do pni w pracy - Drzewus nr 11"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/06/Frezarka-pien-blisko.jpg"
              alt="Frezarka do pni - zbliżenie na piń frezarki"
              className="h-full object-cover w-full"
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default Offer1FrezowaniePni;
